import request from "./axios";
import moment from "moment-timezone";
const { CONFIG } = require("../../config");

const getTeams = (authParams, filter) => {
  const { clientId, authToken } = authParams;
  const options = {
    method: "POST",
    url: `${CONFIG.LOCUS?.[clientId]?.LOCUS_PROD_BASE_URL}/v1/client/${clientId}/team-master-search`,
    data: filter,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return request(options);
};

const getSlots = (authParams) => {
  const { clientId, authToken } = authParams;
  const options = {
    method: "GET",
    url: `${CONFIG.LOCUS?.[clientId]?.LOCUS_PROD_BASE_URL}/v1/client/${clientId}/namespace/motiontrack/settings`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return request(options);
};

const getAllGroups = (authParams, tourBody) => {
  const { clientId, authToken } = authParams;
  const options = {
    method: "POST",
    url: `${CONFIG.LOCUS.LILY_API?.[`LILY_PROD_BASE_URL_${clientId}`]}/v1/client/${clientId}/group`,
    data: tourBody,
    headers: { Authorization: `Bearer ${authToken}` },
  };
  return request(options);
};

export const getSession = ({ authToken, clientId }) => {
  const options = {
    method: "GET",
    baseURL: CONFIG.LOCUS?.[clientId]?.LOCUS_DASH_BASE_URL,
    url: `/session/me`,
    headers: { Authorization: `Bearer ${authToken}` },
  };

  return request(options);
};

export const createPaymentStatus = (reqBody, clientId, orderId, status) => {
  const options = {
    method: "POST",
    baseURL: CONFIG.LOCUS?.[clientId]?.LILY_PAYMENT_BASE_URL,
    url: `/v1/client/${clientId}/order-proxy/order/${orderId}/${status}?webPage=true`,
    headers: { Authorization: null },
    data: reqBody,
  };

  return request(options);
};

export const getRiderToursToday = ({ clientId, authToken }, riderId, dateOverride) =>
  request({
    method: "POST",
    baseURL: CONFIG.LOCUS?.[clientId]?.LOCUS_PROD_BASE_URL,
    url: `/v1/client/${clientId}/tour-search?include=TOUR_VISITS,TASKS,SEQUENCE,COUNTS`,
    headers: { Authorization: `Bearer ${authToken}` },
    data: {
      filters: [
        { name: "fleetInfo.riderId.riderId", operation: "EQUALS", value: riderId },
        {
          name: "date",
          operation: "EQUALS",
          value: dateOverride || moment().tz(CONFIG.TIMEZONE).format("YYYY-MM-DD"),
        },
      ],
      page: 1,
      size: 25,
    },
  });

export const apiService = {
  getTeams,
  getAllGroups,
  getSlots,
  getSession,
};
